import { Divider, Typography } from '@mui/material'
import cn from 'classnames'
import { useTranslations } from 'next-intl'
import { ComponentProps } from 'react'
import { useHits } from 'react-instantsearch'
import { SearchPageTitle } from './SearchPageTitle'
import { ToggleFiltersButton } from './ToggleFiltersButton'

type CoursesPageHeaderProps = ComponentProps<'header'> & {
  onFilterButtonClick: () => void
}

export function CoursesPageHeader({
  onFilterButtonClick,
  ...props
}: CoursesPageHeaderProps) {
  const { results: { nbHits = 0 } = {} } = useHits()
  const t = useTranslations('CoursesPageHeader')

  return (
    <header
      {...props}
      className={cn(
        'flex flex-col items-start gap-4 md:border-b md:py-8',
        props.className
      )}
    >
      <div className="container flex flex-wrap gap-6">
        <SearchPageTitle variant="h1" />
        <div className="hidden items-center justify-center rounded-lg border border-mydra-black px-3 py-2 md:flex">
          <Typography>{t('course_results', { nbHits })}</Typography>
        </div>
      </div>
      <Divider className="w-full border-divider-light md:hidden" />
      <div className="container flex w-full items-center justify-between gap-4 md:hidden">
        <ToggleFiltersButton onClick={onFilterButtonClick} disableRipple />
        <Typography variant="body3" className="p-2 font-title">
          {t('course_results', { nbHits })}
        </Typography>
      </div>
    </header>
  )
}
